<template>
  <v-container>
    <v-card v-bind:style="styleObject">
      <div class="card-header" style="background-color: #004a7b !important;">
        <span class="font-weight-regular">BuyYoSimulasi</span>
      </div>

      <v-text-field
        v-model="seeLevel"
        label="see level"
      ></v-text-field>
      <v-text-field
        v-model="lastLevel"
        label="last level"
      ></v-text-field>

      <v-btn @click="onClick()">Simulated</v-btn>
      <v-data-table
          :headers="headers"
          :items="listSimulasi"
          class="elevation-1"
          color="green lighten-1"
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find, uniqBy } from "lodash";
import moment from 'moment';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
const db = firebase.firestore();
export default {
  name: "BuyYoSimulasi",
  components: {
  },
  data() {
    return {
      styleObject: {
        width: "fit-content",
        margin: "1rem auto",
        borderRadius: "8px",
      },
      menu: false,
      inputDate: null,
      listSimulasi: [],
      startLevel: 0,
      seeLevel: null,
      lastLevel: null,
      headers: [
          {text: 'Level',value: 'level'},
          {text: 'Anggota',value: 'anggota'},
          {text: 'Bonus',value: 'bonus'},
          {text: 'Penerimaan App',value: 'penerimaanApp'},
          {text: 'Vchr.Allocated/Level',value: 'voucherAllocated'},
      ],
    };
  },
  computed: {
      ...mapGetters({
      }),
      ...mapState({
          snackbar: state => state.snackbar,
      })
  },
  mounted() {
  },

  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onClick(){
      this.listSimulasi = []
      const priceSlot = 100000
      const feeTotal = 0.075
      const leg = 4
      const depth = 5
      const arrayLevel = [0,5000,1250,312.5,78.125,19.53125,0,0,0,0,0]
      let tempVoucher = 0
      const value = (Number(this.lastLevel)-Number(this.seeLevel))+1
      let i;
      for (i = 0; i < value; i++) {
        console.log('i', i)
        console.log('leg', leg)
        console.log('tempVoucher', tempVoucher)
        tempVoucher = tempVoucher+(Math.pow(leg,(Number(this.seeLevel)+i))*arrayLevel[i])
        console.log('Math.pow(leg,i)', Math.pow(leg,Number(this.seeLevel)+i))
        console.log('arrayLevel[i]', arrayLevel[i])
        console.log('calculate', (Math.pow(leg,Number(this.seeLevel)+i)*arrayLevel[i]))
        console.log('tempVoucher', tempVoucher)
      }

      this.listSimulasi.push({
        level: Number(this.seeLevel),
        anggota: Math.pow(leg,this.seeLevel),
        bonus: Number(this.seeLevel)*(Math.pow(leg,(this.seeLevel-1))),
        penerimaanApp: Math.pow(leg,Number(this.seeLevel))*(priceSlot*feeTotal),
        voucherAllocated: tempVoucher,
      })
    }
  }
};
</script>
<style scoped>
.card-header {
  text-align: center;
  padding: 1rem;
}
.card-header span {
  margin: 0;
  color: #fff;
}
.btn {
  background-color: #004d40 !important;
  color: #fff;
  padding: 0;
  text-transform: capitalize !important;
  /* font-size:1.3rem */
}
</style>
